import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Row, { Slot } from './row'
import styles from '../component-styles/features-settings-card.module.scss'
import { toggleModuleAvailability } from '../api-client/settings-client'
import { SiteState } from '../store/site-reducer'
import { getSelectedAccountAsync, getUserDetailsAsync } from '../store/actions'

export default function FeatureSettingsCard() {
  const dispatch = useDispatch()
  const { selected } = useSelector(({ site }: { site: SiteState }) => site)

  return (
    <div className={styles.wrapper}>
      <div className={styles.body}>
        <Row className={styles.bodyItem} vAlign="center" align="flex-start">
          <Slot
            align="flex-start"
            vAlign="center"
            className={styles.bodyItemSlot}
          >
            <h3>Track</h3>
            <p>Make and manage campaign links, to optimise media spend.</p>
          </Slot>
          <Slot align="flex-end" vAlign="center" width={100}>
            <button
              className={
                selected?.trackAvailable ? styles.enabled : styles.disabled
              }
              onClick={async () => {
                const res = await toggleModuleAvailability({ module: 'track' })
                if (res) {
                  dispatch(getSelectedAccountAsync())
                  dispatch(getUserDetailsAsync())
                }
              }}
            >
              {selected?.trackAvailable ? 'Enabled' : 'Disabled'}
            </button>
          </Slot>
        </Row>
        <Row className={styles.bodyItem} vAlign="center" align="flex-start">
          <Slot
            align="flex-start"
            vAlign="center"
            className={styles.bodyItemSlot}
          >
            <h3>Audit</h3>
            <p>
              Find and fix issues in your Google Analytics data which effect
              your data quality.
            </p>
          </Slot>
          <Slot align="flex-end" vAlign="center" width={100}>
            <button
              className={
                selected?.auditAvailable ? styles.enabled : styles.disabled
              }
              onClick={async () => {
                const res = await toggleModuleAvailability({ module: 'audit' })
                if (res) {
                  dispatch(getSelectedAccountAsync())
                  dispatch(getUserDetailsAsync())
                }
              }}
            >
              {selected?.auditAvailable ? 'Enabled' : 'Disabled'}
            </button>
          </Slot>
        </Row>
        <Row className={styles.bodyItem} vAlign="center" align="flex-start">
          <Slot
            align="flex-start"
            vAlign="center"
            className={styles.bodyItemSlot}
          >
            <h3>Report</h3>
            <p>
              Create and share reports which explain your websites performance.
            </p>
          </Slot>
          <Slot align="flex-end" vAlign="center" width={100}>
            <button
              className={
                selected?.reportAvailable ? styles.enabled : styles.disabled
              }
              onClick={async () => {
                const res = await toggleModuleAvailability({ module: 'report' })
                if (res) {
                  dispatch(getSelectedAccountAsync())
                  dispatch(getUserDetailsAsync())
                }
              }}
            >
              {selected?.reportAvailable ? 'Enabled' : 'Disabled'}
            </button>
          </Slot>
        </Row>
        <Row className={styles.bodyItem} vAlign="center" align="flex-start">
          <Slot
            align="flex-start"
            vAlign="center"
            className={styles.bodyItemSlot}
          >
            <h3>Explain</h3>
            <p>Spot anomalies, find insights and act to improve performance.</p>
          </Slot>
          <Slot align="flex-end" vAlign="center" width={100}>
            <button
              className={
                selected?.explainAvailable ? styles.enabled : styles.disabled
              }
              onClick={async () => {
                const res = await toggleModuleAvailability({
                  module: 'explain',
                })
                if (res) {
                  dispatch(getSelectedAccountAsync())
                  dispatch(getUserDetailsAsync())
                }
              }}
            >
              {selected?.explainAvailable ? 'Enabled' : 'Disabled'}
            </button>
          </Slot>
        </Row>
      </div>
    </div>
  )
}
